import { useState, ChangeEvent } from 'react';

//import { Helmet } from 'react-helmet-async';
import { Box, Tabs, Tab, Grid, styled } from '@mui/material';

import { useTranslation } from 'react-i18next';
import ParametersGasStationTabCreate from './ParametersGasStationTabCreate';
import ParametersCryoptoPaymentTabCreate from './ParametersCryoptoPaymentTabCreate';
import InfoProjectTabCreate from './InfoProjectTabCreate';
import { useRecordContext, CreateBase, Create, SimpleForm, Toolbar, SaveButton } from "react-admin";
import ComponentEdit from '../../../components/PageComponents/ComponentEdit';
const TabsWrapper = styled(Tabs)(
  () => `
`
);
const Content = () => {

  return (<ComponentEdit title="New entity" subtitle="Create an entity and choose how it accepts payments.">
    <ContentCreate />
  </ComponentEdit>)
}
const ProjectEdit = () => {
  return (
    <>
    <CreateBase >
      <Content/>
    </CreateBase>
    </>

  )
}

const ParametersTab = () => {
  const record = useRecordContext();
  if (!record) return null;
  const tabByProjectType = {
    "gasStation": <ParametersGasStationTabCreate/>,
    "cryptoPayment": <ParametersCryoptoPaymentTabCreate />,
  };
  
  // Return the component directly without casting
  return tabByProjectType[record.typeProject] || null;
}

const ContentCreate = () => {

  const [currentTab, setCurrentTab] = useState<string>('infoProject');
  const { t }: { t: any } = useTranslation();

  const tabs = [
    { value: 'infoProject', label: t('Information') },
    { value: 'parameters', label: t('Parameters') },
  ];

  const handleTabsChange = (_event: ChangeEvent<{}>, value: string): void => {
    setCurrentTab(value);
  };

  return (
    <>
      <Box
        sx={{
          mt: 3,
          marginBottom:4
        }}
      >
        <Grid
          sx={{
            px: 4,
          }}
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={4}
        >

          <Grid item xs={10} md={10}>
            <TabsWrapper
              onChange={handleTabsChange}
              value={currentTab}
              variant="scrollable"
              scrollButtons="auto"
              textColor="primary"
              indicatorColor="primary"
            >
              {tabs.map((tab) => (
                <Tab key={tab.value} label={tab.label} value={tab.value} />
              ))}
            </TabsWrapper>
          </Grid>
          <Grid item xs={2} md={2} sx={{display: 'flex', justifyContent: 'flex-end'}}>
            
          </Grid>
          <Grid item xs={12} md={12}>
          <Create redirect="show" actions={false}>
          <SimpleForm toolbar={<Toolbar sx={{ m: 2 }}><SaveButton label={t("Create entity")} /></Toolbar>}>
            {currentTab === 'infoProject' && <InfoProjectTabCreate />}
            {currentTab === 'parameters' && <ParametersTab />}
          </SimpleForm>
          </Create>
          </Grid>
        </Grid>
      </Box>
      </>
  );
}

export default ProjectEdit